import type { GrowerException } from 'common/src/utils/presettlement-grower-exceptions';
import type { TariffConfiguration } from 'common/src/utils/presettlement-tariffs';

export interface CalculationSettingsSnapshot {
  calculation_criteria: string | null;
  product_definition: string[];
  cost_type: 'sameCost' | 'formatCost';
  commission_percentage: number;
  grower_exceptions?: GrowerException[];
  consider_extra_revenue: boolean;
  tariff_configuration: TariffConfiguration;
}

// Compare values rather than selection order or object insertion order.
export function calculationSettingsSnapshot(
  settings: CalculationSettingsSnapshot
): string {
  const tariff = settings.tariff_configuration;
  return JSON.stringify({
    calculation_criteria: settings.calculation_criteria,
    product_definition: [...new Set(settings.product_definition)].sort(),
    cost_type: settings.cost_type,
    commission_percentage: settings.commission_percentage,
    consider_extra_revenue: settings.consider_extra_revenue,
    grower_exceptions: (settings.grower_exceptions ?? [])
      .map((rule) => ({
        growers: [...rule.growers].sort(),
        commissionPercentage: rule.commissionPercentage,
        tariff: rule.tariff && {
          mode: rule.tariff.mode,
          value: rule.tariff.value,
        },
      }))
      .sort((a, b) =>
        JSON.stringify(a.growers).localeCompare(JSON.stringify(b.growers))
      ),
    tariff_configuration: {
      version: tariff.version,
      packing: tariff.packing,
      packaging: tariff.packaging,
      week: tariff.week,
      defaultRate: tariff.defaultRate,
      rates: Object.entries(tariff.rates).sort(([a], [b]) =>
        a.localeCompare(b)
      ),
    },
  });
}
